export class SearchHelper {
    // Object Struct to use the method
    // { filter: "", data: [], fields: [], callbackComparison: {"field": callback(fieldValue)}, boolComparison: { "filterText": "field" }, valueParser: { "field": { "value1": "compare1", "value2": "compare2" } } }
    static search(args) {
        const { filter, data, fields, callbackComparison, boolComparison, valueParser } = Object.assign({ filter: "", data: [], fields: [], callbackComparison: [], boolComparison: [], valueParser: [] }, args);

        if (undefined === filter || "" === filter) {
            return data;
        }

        const filterUpper = filter.toUpperCase();
        
        const upperBoolComparison = {};
        for (let idx in boolComparison) {
            upperBoolComparison[`${idx}`.toUpperCase()] = boolComparison[idx];
        }

        if (!Array.isArray(fields) || 0 === fields.length) {
            try {
                return data.filter(function (element) {
                    if (undefined === element || "" === element) {
                        return false;
                    }

                    return `${element}`.toUpperCase().includes(filter.toUpperCase());
                });
            }
            catch (_) {
                return data;
            }
        }

        const filterWordsUpper = filterUpper.split(" ")
            .filter(word => "" !== word)
            .map(word => `${word}`);

        return data.filter((element) => {
            const matchWords = filterWordsUpper.reduce((output, word) => {
                output[`${word}`] = false
                return output
            }, []);

            for (let idx in fields) {
                const fieldPath = `${fields[idx]}`;
                const fieldProperties = fieldPath.split(".");

                let filteredElement = element;
                for (let field in fieldProperties) {
                    filteredElement = filteredElement[fieldProperties[field]];
                    if (undefined === filteredElement) {
                        break;
                    }
                }

                if (undefined !== filteredElement) {
                    const field = fieldProperties.slice(-1)[0];
                    const callbackComparisonObject = callbackComparison.find(f => fieldPath in f);

                    if(this.searchField(filterUpper, filteredElement, fieldPath, field, valueParser, upperBoolComparison, callbackComparisonObject)) {
                        return true;
                    }

                    for(let word in filterWordsUpper) {
                        if(this.searchField(filterWordsUpper[word], filteredElement, fieldPath, field, valueParser, upperBoolComparison, callbackComparisonObject)) {
                            matchWords[filterWordsUpper[word]] = true;
                        }
                    }
                }
            }

            if(Object.values(matchWords).every(match => match)) {
                return true;
            }

            return false;
        });
    }

    static searchField(filter, filteredElement, fieldPath, field, valueParser, upperBoolComparison, callbackComparisonObject) {
        if (undefined === valueParser[fieldPath]) {
            if ("boolean" === typeof filteredElement) {
                let comparisionField = upperBoolComparison[filter];
                if (undefined === comparisionField) {
                    comparisionField = filter;
                }

                if (field.toUpperCase() === comparisionField && filteredElement) {
                    return true;
                }
            }
            else if (undefined !== callbackComparisonObject && "function" === typeof callbackComparisonObject[fieldPath]) {
                if (`${callbackComparisonObject[fieldPath](filteredElement)}`.toUpperCase().includes(filter)) {
                    return true;
                }
            }
            else if (`${filteredElement}`.toUpperCase().includes(filter)) {
                return true;
            }
        }
        else if (undefined !== valueParser[fieldPath] && undefined !== valueParser[fieldPath][filteredElement] && `${valueParser[fieldPath][filteredElement]}`.toUpperCase().includes(filter)) {
            return true;
        }
        
        return false;
    }
}
